import { render, staticRenderFns } from "./UserCouponList.vue?vue&type=template&id=3381aa30&scoped=true"
import script from "./UserCouponList.vue?vue&type=script&lang=js"
export * from "./UserCouponList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3381aa30",
  null
  
)

export default component.exports